import React from "react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import useTranslate from "@default/hooks/use-translate";
import { useSolrContext } from "@e-fork/solr";
import DashedBorder from "@default/general-components/dashed-border";

const InlineSelectFacet = ({ id, label, multiple, isFrontendId }) => {
  const _t = useTranslate();
  const { facets, setFilter, currentFilters, resetFilter } = useSolrContext();

  if (!facets || !facets.length) {
    return null;
  }

  const facet = facets.find((facet) => facet.key === id);

  if (!facet) {
    return null;
  }

  const possibleFacets = facet.results;

  const customOptions = possibleFacets.map((term) => ({
    label: isFrontendId ? _t(`overview.facets.${id}.${term.key}`) : term.label,
    value: term.key,
  }));

  const hasSelection = currentFilters?.[id]?.length > 0;

  const isActive = (value) => {
    if (multiple) {
      return currentFilters?.[id]?.includes(value) ?? false;
    }
    return currentFilters?.[id]?.[0] === value;
  };

  const handleOptionClick = (value) => {
    if (!multiple) {
      if (currentFilters?.[id]?.[0] === value) {
        resetFilter(id);
      } else {
        setFilter(id, [value]);
      }
    } else {
      const current = currentFilters?.[id] || [];
      if (current.includes(value)) {
        const next = current.filter((v) => v !== value);
        if (next.length === 0) {
          resetFilter(id);
        } else {
          setFilter(id, next);
        }
      } else {
        setFilter(id, [...current, value]);
      }
    }
  };

  return (
    <div
      className="main-control group-switch filter-control-element day-controls"
      style={{
        "--animation-children": customOptions.length + 1,
        "--current-index": 0,
        "--opacity": 0,
      }}
    >
      <DashedBorder/>
      <small className="d-block label sr-only">{label}</small>
      <button
        className={classNames("font-style-change", { active: !hasSelection })}
        onClick={() => resetFilter(id)}
        aria-label={`${label}: ${_t("weekday.reset")}`}
      >
        <span className="highlighted">
          <FormattedMessage id="weekday.reset" />
        </span>
        <span className="standard">
          <FormattedMessage id="weekday.reset" />
        </span>
      </button>
      {customOptions.map((option) => (
        <button
          key={option.value}
          className={classNames("font-style-change", {
            active: isActive(option.value),
          })}
          aria-label={`${label}: ${option.label}`}
          onClick={() => handleOptionClick(option.value)}
        >
          <span className="highlighted">{option.label}</span>
          <span className="standard">{option.label}</span>
        </button>
      ))}
    </div>
  );
};

InlineSelectFacet.propTypes = {};

export default InlineSelectFacet;
